// extracted by mini-css-extract-plugin
var _1 = "footer-module__bottomSection___tLXNX";
var _2 = "footer-module__container___NcUYx";
var _3 = "footer-module__createdBy___orS90";
var _4 = "footer-module__topSection___g6APa";
export { _1 as "bottomSection", _2 as "container", _3 as "createdBy", _4 as "topSection" }
